import { AdminAppState, PagesState } from '../../state';

export const getPages = (state: AdminAppState): PagesState => state.pages;
